mutation UpdateTheme($theme: String!) {
  updateTheme(theme: $theme) {
    ok
    errors
  }
}
